export const testName = (str, space) => {
	const regEx = /^[가-힣a-zA-Z]+$/;
	if (regEx.test(str)) return true;
	if (space) return /^[a-zA-Z]+( [a-zA-Z]+)*$/.test(str); // 영어 (이름사이 띄어쓰기허용)
	return false;
};

export const testEmail = (str) => {
	const regEx = /^[0-9a-zA-Z_]([-_.]?[0-9a-zA-Z_-])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
	return regEx.test(str);
};

export const testMobile = (str) => {
	const regEx = /^01(0|1|[6-9]{1})-?([0-9]{3,4})-?([0-9]{4})$/;
	return regEx.test(str);
};

export const testTel = (str) => {
	const regEx = /(^02|^0502|^0504|^0505|^0506|^1[0-9]{3}|^0[0-9]{2})-?([0-9]+)?-?([0-9]{4})/;
	return !testMobile(str) && regEx.test(str);
};

export const testNumber = (str) => {
	const regEx = /^[0-9]+$/;
	return regEx.test(str);
};

// 4~12자리 소문자 + 숫자 조합
export const testId = (str) => {
	const regEx = /^[a-z0-9]{4,12}$/;
	return regEx.test(str);
};

// 한글, 영문, 숫자, - 만 입력 가능 (매매사원증번호)
export const testSalesNumber = (str) => {
	const regEx = /^[ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z0-9-]+$/;
	return regEx.test(str);
};

// 특수문자 제외한 한글, 영문, 숫자 만 입력 가능 , 천지인 키보드에서의 middle dot(·,ᆢ)까지 포함
export const testExcludeSpecialCharacter = (str) => {
	const regEx = /^[ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z0-9ㆍᆢ]+$/;
	return regEx.test(str);
};

// 한글 체크
export const testKor = (str) => {
	const regEx = /[ㄱ-ㅎㅏ-ㅣ가-힣]/;
	return regEx.test(str);
};

export const testFullUrl = (str) => {
	const regEx = /^http/g;
	return regEx.test(str);
};

export const testMobileSiteByOrigin = (str) => {
	const regEx = /(?:\/\/)(m|mnew|mrelease)\.encar|io:83|m\.k8s/g;
	return regEx.test(str);
};

// 차량번호 00가0000, 000가0000, 서울00가0000, 서울000가0000
export const testCarNumber = (str) => {
	const regEx = /^[0-9]{2,3}[가-힣]{1}[0-9]{4}$|^[가-힣]{2}[0-9]{2,3}[가-힣]{1}[0-9]{4}$/;
	return regEx.test(str);
};

// 특수문자 제외한 한글, 영문 입력 가능 , 천지인 키보드에서의 middle dot(·,ᆢ)까지 포함
export const testKoreanEnglish = (str) => {
	const regEx = /^[ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Zㆍᆢ]+$/;
	return regEx.test(str);
};

// 이름 마스킹
export const maskName = (name) => {
	if (!name || typeof name !== 'string' || name.length <= 1) return name;

	const { length } = name;
	const [firstChar] = name;

	// 두 글자: 첫 글자 + *
	if (length === 2) return `${firstChar}*`;

	// 세 글자 이상: 첫 글자 + * + 마지막 글자
	return `${firstChar}${'*'.repeat(length - 2)}${name[length - 1]}`;
};
